module.exports = __webpack_public_path__ + "static/media/sup_icons_EA.461e8b8b.svg";